<template>
  <div class="page">
    <section class="section">
      <div class="container">
        <h1 class="title is-h1 is-page-title">
          {{ title }}
        </h1>
        <div v-if="body" class="content" v-html="body" />
      </div>
      <div class="container">
        <div class="columns">
          <div class="column is-8-desktop is-12">
            <div v-if="entity" class="mt-4">
              <Webform
                class="webform-iframe"
                :webform="entity"
                :source-entity-id="sourceEntityId"
                :source-entity-type="sourceEntityType"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import type { NodeWebformFragment, WebformFragment } from '#graphql-operations'

const props = defineProps<NodeWebformFragment>()

const { data: entity } = await useAsyncData(async () => {
  return useGraphqlQuery('webform', {
    id: props.webform?.id || '',
  }).then((v) => v.data.webform as WebformFragment)
})

const sourceEntityType = 'node'
const sourceEntityId = `${props.nid}`
</script>
